<section class="premiit_header">
  <hr class="premiit_bar" [class.loading]="loading"/>
  <div class="premiit_content">
    <div class="premiit_content-branch">
      <app-premiit-chip></app-premiit-chip>
      <img class="premiit_content-branch-logo" src="assets/images/premiit-logo-colors.svg" alt="premiit-blue">
    </div>
    <div class="premiit_content-menu">
      <span *ngFor="let route of routing"
        class="premiit_content-menu-item"
        [routerLink]="[route.route]"
        routerLinkActive="active-route">
        {{route.esTitle}}
      </span>
      <div (click)="logout()">
        <fa-icon class="premiit_content-menu-powerOff" [icon]="faPowerOff"></fa-icon>
      </div>
    </div>
  </div>
</section>